export const dealershipBrandOptions = [
  { label: 'BMW', id: 'bmw' },
  { label: 'Jaguar Land Rover', id: 'jlr' },
  { label: 'Mercedes-Benz', id: 'mercedes' },
  { label: 'Volkswagen Malaysia', id: 'vw' },
  { label: 'BYD', id: 'byd' },
  { label: 'Volkswagen Singapore', id: 'vwsg' },
]

export const availableDealershipBrands = ['bmw', 'jlr', 'mercedes', 'vw', 'byd', 'vwsg']

let dealershipBrandsDict = {}

for (const option of dealershipBrandOptions) {
  dealershipBrandsDict[option.id] = option.label
}

export default dealershipBrandsDict
